import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Colors from '../utils/colors';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '128px',
  },
  spacer: {
    height: '80px',
    backgroundColor: 'white'
  },
  container: {
    display: 'flex', 
    flexDirection: 'row',
    justifyContent: 'flex-end',
    backgroundColor: Colors.primary,
    color: 'white',
    height: '48px',
    width: '100%'
  },
  transaltaIcon: {
    height: '30px',
    margin: '9px'
  },
}));

export default function DashboardFooter() {
  const classes = useStyles();

  return (
    <footer className={classes.root}>
      <div className={classes.spacer}></div>
      <div className={classes.container}>
        <img src={process.env.PUBLIC_URL + '/Icon_Blue.png'}
             alt="TransAlta" id="logo"
             className={classes.transaltaIcon} />
      </div>
    </footer>
  );
}

